import React from 'react';
// import store, { history } from 'store';
import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { history, store } from 'store';

const theme = createTheme({
    typography: {
        fontFamily: ['Poppins', 'sans-serif'].join(',')
    }
});

export const AppProviders: React.FC<{ children: React.ReactNode }> = props => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
            </ConnectedRouter>
        </Provider>
    );
};
